/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import {ajax, Status, arrayFrom, getState} from '../../twd/twd'

export default () => {
    const state = getState('corporates.scatter-graph')

    const [status, setStatus] = React.useState(Status.LOADING)
    const benchmarks = ['Treasury', 'AAA', 'AA', 'A', 'BBB']
    const [benchmarksData, setBenchmarksData] = React.useState({})

    const [selectedBenchmarks, setSelectedBenchmarks_] = React.useState(state.value.selectedBenchmarks || benchmarks)
    const setSelectedBenchmarks = React.useCallback((a) => {
        state.set({selectedBenchmarks:a})
        setSelectedBenchmarks_(a)
    }, [])

    const lastDataAbort = React.useRef()

    React.useEffect(() => {(async () => {
        try {
            setStatus(Status.LOADING)
            if (lastDataAbort.current) lastDataAbort.current()

            let {data, abort} = await ajax({
                url: '/esb/retailservice/yieldCurveService/getBenchmarkDataByType',
                method: 'POST',
                params: {
                    bondType: 'CORP',
                    marketSnapshotType: 'CORPORATE_BENCHMARK_DATA',
                    useCache:true,
                }
            })

            lastDataAbort.current = abort
            let a = (await data).benchmarkYieldValues || {}
            lastDataAbort.current = null

            let m = {
                'Treas': 'Treasury',
                'CorpAAA': 'AAA',
                'CorpAA': 'AA',
                'CorpA': 'A',
                'CorpBBB': 'BBB',
            }
            for (let [k, v] of Object.entries(a)) {

                let n = m[k]
                if (!n) continue

                a[n] = arrayFrom(v)
                    .map(i => {
                        i.benchmark = n
                        i.x = i.maturityYearValue
                        i.y = i.yieldValue
                        return i
                    })
                    .filter(a => (a.x<=30))
            }
            setBenchmarksData(a)

            setStatus(Status.LOADED)
        } catch(e) {
            if (lastDataAbort.current) lastDataAbort.current()
            setStatus(Status.FAILED_TO_LOAD)
        }
    })()

    return () => {
        if (lastDataAbort.current) lastDataAbort.current()
    }
}, [])


    return {
        benchmarks,
        benchmarksStatus: status,
        benchmarksData,
        selectedBenchmarks,
        setSelectedBenchmarks
    }
}